module.exports = __webpack_public_path__ + "img/Illustration.82dc5fe3.png";